import { combineReducers } from "@reduxjs/toolkit";
import tempDataStorageSlice from "./slices/tempDataStorageSlice";

const rootReducer = combineReducers({
  tempDataStorage: tempDataStorageSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
